module.exports = __webpack_public_path__ + "static/img/chaxun.1d686d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/chaxun.png
// module id = yBDz
// module chunks = 5